import { useEffect, useState } from 'react';
import cls from 'classnames'

import { analytics, getPrintDetail } from '@/utils/analytics';

import Button from '@/atoms/Button/Button';
import Icon from '@/atoms/Icon/Icon';
import Pill from '@/atoms/Pill/Pill';
import Text from '@/atoms/Text/Text';
import SocialShare from '@/molecules/SocialShare/SocialShare';
import BottomSheet from '@/organisms/BottomSheet/BottomSheet';

export default function ContentFooter({ tags, entries, fields, pageTitle }) {
  const [open, setOpen] = useState(false);
  const [pageUrl, setPageUrl] = useState('');

  const openWindowPrint = (e) => {
    analytics({
      window,
      document,
      detail: getPrintDetail(e),
    });
    window?.print();
  };
  const openShare = () => setOpen(true);
  const closeShare = () => setOpen(false);

  useEffect(() => {
    if (window?.location) {
      setPageUrl(window.location.href);
    }
  }, []);

  if (!tags?.length) return null;

  const featuredTags = tags?.filter((tag) => tag?.fields?.featured);

  return (
    <div className={cls('aaco-content-footer hidden-print',
      'container mx-auto flex flex-col md:flex-row md:justify-between',
      'mb-14 dd-kr:mb-10 dd-en:mb-10 md:py-9 dd-en:md:mb-0 md:mb-20 dd-kr:md:mb-0'
    )}>
      <div className={cls(
        'aaco-content-footer__tags',
        ' flex flex-wrap gap-x-[6px] dd-en:gap-x-1 dd-kr:gap-x-1',
        'md:mr-7'
      )}>
        {featuredTags?.length > 0 &&
          featuredTags.map((tag) => (
            <Pill
              key={tag?.fields?.name}
              tag="body"
              style="pill-action cursor-pointer mb-2 md:m-[5px] md:ml-0"
              onClick={() => {/* Search disabled */}}
            >
              {tag?.fields?.name}
            </Pill>
          ))}
      </div>
      <div className={cls('aaco-content-footer__action', 'flex gap-[23px] dd-en:gap-7 dd-kr:gap-7', 'mr-7 mt-4 md:mt-0')}>
        <Button style="aaco-print flex items-center" onClick={openWindowPrint}>
          <Icon
            className="mr-2.5 md:mr-3.5 text-acacia dd-kr:text-body-text-grey dd-en:text-body-text-grey"
            height={18}
            name="print"
            width={18}
          />
          <Text
            tag="button"
            style="text-black dd-kr:text-body-text-grey dd-en:text-body-text-grey"
          >
            Print
          </Text>
        </Button>
        <Button style="aaco-share flex items-center" onClick={openShare}>
          <Icon
            className="mr-2.5 md:mr-3.5 text-acacia dd-kr:text-body-text-grey dd-en:text-body-text-grey"
            height={14}
            name="share"
            width={14}
          />
          <Text
            tag="button"
            style="text-black dd-kr:text-body-text-grey dd-en:text-body-text-grey"
          >
            Share
          </Text>
        </Button>
      </div>
      <BottomSheet open={open} onDismiss={closeShare}>
        <SocialShare url={pageUrl} size={50} title={pageTitle} />
      </BottomSheet>
    </div>
  );
}
